import { CheckStatus, GetWorkOrdersResponseDTO } from '@gearbelt/global';

import { Badge } from '@/components/ui/badge';
import { formatScheduleCheckLabel } from '@/utils/schedules';

type WorkOrderIssue = NonNullable<GetWorkOrdersResponseDTO['data'][number]['issues']>[number];
type WorkOrderCheck = NonNullable<GetWorkOrdersResponseDTO['data'][number]['checks']>[number];

export function renderIssueBadges(issues: WorkOrderIssue[]) {
  if (issues.length === 0) {
    return <span className="text-secondary-text text-sm">-</span>;
  }
  return (
    <div className="flex min-w-0 items-center gap-1">
      {issues.slice(0, 3).map((issue) => (
        <Badge key={`issue-${issue.id}`} variant="orange" size="sm" className="max-w-[120px] min-w-0">
          <span className="truncate">{issue.title || issue.description || `Issue #${issue.number ?? ''}`}</span>
        </Badge>
      ))}
      {issues.length > 3 && <span className="text-secondary-text shrink-0 text-sm whitespace-nowrap">+{issues.length - 3} more...</span>}
    </div>
  );
}

export function renderCheckBadges(checks: WorkOrderCheck[]) {
  const filteredChecks = checks.filter((check) => check.status !== CheckStatus.Void);
  if (filteredChecks.length === 0) {
    return <span className="text-secondary-text text-sm">-</span>;
  }
  return (
    <div className="flex min-w-0 items-center gap-1">
      {filteredChecks.slice(0, 3).map((check) => (
        <Badge key={`check-${check.id}`} variant="violet" size="sm" className="max-w-[120px] min-w-0">
          <span className="truncate">{formatScheduleCheckLabel(check) || check.schedule?.name || 'Schedule'}</span>
        </Badge>
      ))}
      {filteredChecks.length > 3 && <span className="text-secondary-text shrink-0 text-sm whitespace-nowrap">+{filteredChecks.length - 3} more...</span>}
    </div>
  );
}
